import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { GroupAvatar } from '@vk-hr-tek/ui/GroupAvatar';
import { FormatService } from '@vk-hr-tek/core/format';
import { useInject } from '@vk-hr-tek/core/ioc';

import { modules } from '@app/modules';

import { ImageParams, SearchCommunityOption } from '../SearchInput.types';
import { useUrlWithPrefix } from '../../../../hooks';

import { SearchOptionMeta } from './SearchOptionMeta';

interface SearchOptionCommunityProps {
  option: SearchCommunityOption;
  loadImage: (params: ImageParams) => Promise<string>;
}

export const SearchOptionCommunity = ({
  option,
  loadImage,
}: SearchOptionCommunityProps) => {
  const format = useInject(FormatService);
  const urlWithPrefix = useUrlWithPrefix();
  const href = `/${modules.community.basename}/${option.id}/${option.slug}`;

  const handleLoadImage = async () => {
    if (!option.avatar_attachment_id) {
      return undefined;
    }

    return loadImage({ id: option.avatar_attachment_id });
  };

  const formattedMembersCount = format.pluralize(option.members_count, [
    'участник',
    'участника',
    'участников',
  ]);

  const labels = [
    { label: option.category, isShrink: true },
    { label: formattedMembersCount, isShrink: false },
  ];

  if (option.is_member) {
    labels.push({ label: 'Вы подписаны', isShrink: false });
  }

  return (
    <Box width="100%" p="8">
      <Link {...urlWithPrefix(href)} variant="simple" display="block">
        <Box width="100%" display="flex" gap="12">
          <Box minHeight="40px" minWidth="40px" height="40px" width="40px">
            <GroupAvatar loadImage={handleLoadImage} size="small" />
          </Box>
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            gap="2"
            maxHeight="60px"
          >
            <SearchOptionMeta labels={labels} />
            <Box>
              <Typography
                maxLinesCount={2}
                variant="body3"
                color="text.light.primary"
                wordBreak="break-all"
              >
                {option.title}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
